/**
 * Centralized link config for the Footer columns.
 * Keeps Footer.jsx free of long inline lists. Test IDs preserved exactly.
 */

export const CATEGORY_LINKS = [
  { to: "/peptides-for-med-spas", label: "All Med Spa Peptides", testid: "footer-link-hub" },
  { to: "/anti-aging-peptides", label: "Anti-Aging & Skin", testid: "footer-link-anti-aging" },
  { to: "/weight-loss-peptides", label: "Weight Loss & Metabolism", testid: "footer-link-weight-loss" },
  { to: "/recovery-peptides", label: "Recovery & Repair", testid: "footer-link-recovery" },
  { to: "/hormone-peptides", label: "Hormone & Longevity", testid: "footer-link-hormone" },
  { to: "/sexual-wellness-peptides", label: "Sexual Wellness", testid: "footer-link-sexual-wellness" },
  { to: "/topical-peptides", label: "Topical Peptides", testid: "footer-link-topicals" },
  { to: "/peptide-glossary", label: "Peptide Glossary", testid: "footer-link-glossary" },
  { to: "/locations", label: "Peptides by State", testid: "footer-link-locations" },
];

export const BUSINESS_LINKS = [
  { to: "/for-med-spas", label: "For Med Spa Owners", testid: "footer-link-for-med-spas" },
  { to: "/for-providers", label: "For Licensed Providers", testid: "footer-link-for-providers" },
  { to: "/wholesale-peptides-for-clinics", label: "Wholesale Research Peptides", testid: "footer-link-wholesale" },
  { to: "/peptide-protocols-for-aesthetic-practices", label: "Protocols Reference", testid: "footer-link-protocols" },
  { to: "/provider-access", label: "Provider Access & Pricing", testid: "footer-link-provider-access-business" },
];

export const SHOP_LINKS = [
  { to: "/shop", label: "All Products" },
  { to: "/provider-access", label: "Provider Access \u0026 Pricing", testid: "footer-link-provider-access" },
  { to: "/affiliate-program", label: "Become an Affiliate", testid: "footer-link-affiliate" },
  { to: "/blog", label: "Research Blog" },
  { to: "/recovery-guide", label: "Recovery Guide" },
];

export const COMPANY_LINKS = [
  { to: "/about", label: "About Us" },
  { to: "/partners", label: "Partners", testid: "footer-link-partners" },
  { to: "/press", label: "Press & Media", testid: "footer-link-press" },
  { to: "/compliance", label: "Compliance", testid: "footer-link-compliance" },
  { to: "/editorial-standards", label: "Editorial Standards", testid: "footer-link-editorial" },
  { to: "/glossary", label: "Glossary API", testid: "footer-link-glossary-api" },
  { to: "/tools/state-regulatory-checker", label: "State Regulatory Checker", testid: "footer-link-checker" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Service" },
  { to: "/refund", label: "Refund Policy" },
  { to: "/shipping", label: "Shipping Policy" },
  { to: "/disclaimer", label: "Disclaimer" },
  { to: "/sitemap", label: "Sitemap", testid: "footer-link-sitemap" },
  { to: "https://dosingmypeptides.com/", label: "Peptide Dosing Calculator \u2197", external: true, testid: "footer-link-dose-calculator" },
];
